import { css } from 'styled-components';

export const ApplicationLayout = css(({ theme }) => {
  return css`
    width: 100%;
    height: 100%;
    display: flex;
    color: ${theme.colors.primaryDeepBlue};

    > .content {
      z-index: 1;
      overflow: hidden;
      width: 100%;
      height: 100%;
      box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
      background-color: ${theme.colors.white};
      display: flex;
      flex-direction: column;

      @media only screen and ${theme.device.max.laptopS} {
        border-radius: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        max-height: none;
      }

      > .top.no-shadow {
        box-shadow: none;

        > .top-bar-container {
          box-shadow: none;
        }
      }

      > .stepper {
        padding: 0 4px;
      }
    }
  `;
});
